/* eslint-disable no-undef */
import { AUTH_EVENTS, CORE_EVENTS } from './contants';

declare global {
  interface Window {
    fbq: (event: 'init' | 'trackCustom' | 'track', name: string, params?: any) => void;
    _fbq: () => void;
  }
}

export const MAIN_TO_FACEBOOK_CONVERSION_EVENTS = {
  [AUTH_EVENTS.signUp]: AUTH_EVENTS.signUp,
  [CORE_EVENTS.startGame]: CORE_EVENTS.startGame,
  [CORE_EVENTS.twoGames]: CORE_EVENTS.twoGames,
  [CORE_EVENTS.fiveGames]: CORE_EVENTS.fiveGames,
  [CORE_EVENTS.tenGames]: CORE_EVENTS.tenGames,
};

class FacebookConversion {
  private init(onSuccess: () => void) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    }) as any;
    if (!window._fbq) {
      window._fbq = n;
    }
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];

    const metaPixelScript = document.createElement('script');
    metaPixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    metaPixelScript.defer = true;

    metaPixelScript.onload = () => {
      window.fbq('init', '471256111813812');
      onSuccess();
    };

    metaPixelScript.onerror = () => {
      console.log('FB events was not loaded');
    };

    return document.head.appendChild(metaPixelScript);
  }

  public trackEvent(name: string) {
    if (!window.fbq) {
      this.init(() => window.fbq('trackCustom', name));
    } else {
      window.fbq('trackCustom', name);
    }

    return false;
  }
}

export default FacebookConversion;
